import React, { Component } from 'react';
import styled from 'styled-components';
import { Box, Button, Small } from '@upsolve/ui';

import LinkCSS from '../Links/A.css';
import Page from './Page.div';

import AboutPanel from './AboutPanel';
import LearnListingPanel from '../Learn/LearnListingPanel';


const FooterContainer = styled.footer`
  background: ${props => props.theme.colors.white[700]};
  a {
    ${LinkCSS}
    font-size: 14px;
  }
  ${ Page } > div {
    display: flex;
    flex-direction: row;
    @media screen and (max-width: 45em) {
      flex-direction: column;
    }
    & > div {
      flex-grow: 1;
      padding: 1em;
    }
  }
  li, p {
    font-size: .8em;
  }
  small {
    line-height: 125%;
    &, a, a:visited, a:active, a:hover {
      color: ${props => props.theme.colors.gray[900]};
    }
    a, a:hover {
      cursor: pointer;
      text-decoration: underline;
    }
  }
  @media screen and (max-width: 45em) {
    li {
      font-size: 1em;
      padding-bottom: 0.25em;
    }
  }
`;

const AttorneyCTA = styled.div`
  background: ${props => props.theme.colors.white[700]};
  & > div {
    max-width: 960px;
    margin: 0 auto;
    text-align: center;
    padding: 2em 1em;
    color: ${props => props.theme.colors.brand[500]};
    & > a {
      color: ${props => props.theme.colors.brand[500]};
    }
    button {
      margin-top: 1em;
    }
  }
`;

class MainFooter extends Component {
  render() {
    return (
      <div>
        {this.props.showArticles === true && <LearnListingPanel />}
        {this.props.showAttorneyLink === true && (
          <AttorneyCTA>
            <div>
              <a aria-busy="false" href="https://local.upsolve.org/join">
                <b>Are you a bankruptcy attorney?</b><br />Create a profile on Upsolve and get exposed to hundreds of clients ready to file bankruptcy.
                <br />
                <Button buttonType="white">Create an Attorney Profile</Button>
              </a>
            </div>
          </AttorneyCTA>
        )}
        <AboutPanel />
        <FooterContainer>
          <Page>
            <div>
              <div>
                <h4>Organization</h4>
                <ul>
                  <li><a aria-busy="false" href="/team/">Team</a></li>
                  <li><a aria-busy="false" href="/supporters/">Supporters</a></li>
                  <li><a aria-busy="false" href="/press/">Press</a></li>
                  <li><a aria-busy="false" href="/donate/">Donate</a></li>
                  <li><a aria-busy="false" href="/careers/">Careers</a></li>
                </ul>
              </div>
              <div>
                <h4>Need help?</h4>
                <ul>
                  <li><a aria-busy="false" href="/learn/">Learning Center</a></li>
                  <li><a aria-busy="false" href="/browse/">Browse Articles and Pages</a></li>
                  <li><a aria-busy="false" href="/legal-definitions/">Legal Definitions</a></li>
                  <li><a aria-busy="false" href="https://local.upsolve.org/join">For Attorneys</a></li>
                </ul>
              </div>
              <div>
                <h4>Terms & Privacy</h4>
                <ul>
                  <li><a aria-busy="false" href="/terms-of-service/">Terms of Service</a></li>
                  <li><a aria-busy="false" href="/terms-of-use/">Terms of Use</a></li>
                  <li><a aria-busy="false" href="/privacy-policy/">Privacy Policy</a></li>
                </ul>
              </div>
              <div>
                <h4>Made in NYC 🗽</h4>
              </div>
            </div>
            <Box padding="0.5em 1em">
              <Small>
                Upsolve is not a law firm or a substitute for an attorney or law firm. Upsolve provides an online web app that helps you file for bankruptcy for free on your own, if you have a simple case and pass our eligibility criteria. We <a aria-busy="false" href="/no-legal-advice">do not provide any form of legal advice</a> and absolutely no communication between you and Upsolve should be considered legal advice. If you do not qualify for our free web app or you do not want to use it, we provide access to private independent attorneys at your specific direction. Attorneys pay Upsolve for the chance to provide free evaluations to people who ask for them, which <a aria-busy="false" href="/learn/transparency/">helps keep our web app free</a>. By using Upsolve, you do not enter any form of attorney-client relationship with Upsolve. Your access to the website is subject to our <a aria-busy="false" href="/terms-of-use">Terms of Use</a>.
              </Small>
            </Box>
          </Page>
        </FooterContainer>
      </div>
    );
  }
}

export default MainFooter
